import styled from 'styled-components';

import {
  Colors,
  Sizes,
} from '@noitada/shared/constants';

import {
  ContentPadderHorizontal,
} from '../../../../../styles/styled.layout';



export interface IProps {
  disabled?: boolean;
}



export const CloseOrderContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const CloseOrderContainer = styled(ContentPadderHorizontal)`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-top: 5px;
  padding-bottom: 5px;
`;



export const CloseOrderButton = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  opacity: ${(props: IProps) => props.disabled ? 0.5 : 1};
`;


export const ListImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 60px;
  margin-right: 15px;
`;

export const ListItemImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

export const ListCompanyImage = styled.img`
  height: 90%;
  width: 90%;
  object-fit: cover;
  border-radius: ${Sizes.cardRadius}px;
`;


export const CloseOrderView = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CloseOrderLabel = styled.p`
  color: ${Colors.white};
  font-size: 17px;
`;

export const CloseOrderSubTitle = styled.p`
  margin-top: 3px;
  color: ${Colors.gray};
  font-size: 14px;
`;
